var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center no-wrap"},[_c('u-progress',{staticClass:"progress-sgrp m-r",staticStyle:{"border-radius":"5px","max-width":"70%"},attrs:{"percentage":_vm.task.progress,"color":"positive","height":"6px"}}),_vm._v(" "+_vm._s(_vm.task.progress)+"% ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }